module.exports = __webpack_public_path__ + "static/media/wallets-logo.9cbec65d.png";